// eslint-disable-next-line import/no-cycle
import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/panda/posIntegration';
const getPosData = (systemSource, merchantId, branchId, payload) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/pos_data`
		),
		payload
	);
};

const updatePosData = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data`),
		payload
	);
};

const disconnect = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data/remove`),
		payload
	);
};

const storeList = (systemSource, merchantId, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/stores`),
		payload
	);
};

const shopStatus = (systemSource, merchantId, payload) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/pos_data/shop_status`
		),
		payload
	);
};

export default { getPosData, updatePosData, disconnect, storeList, shopStatus };
